import { render, staticRenderFns } from "./Chatbase.vue?vue&type=template&id=0eec72a2&scoped=true"
import script from "./Chatbase.vue?vue&type=script&lang=ts"
export * from "./Chatbase.vue?vue&type=script&lang=ts"
import style0 from "./Chatbase.scss?vue&type=style&index=0&id=0eec72a2&prod&lang=scss&scoped=true&external"
import style1 from "./Chatbase.vue?vue&type=style&index=1&id=0eec72a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eec72a2",
  null
  
)

export default component.exports